import React from 'react';
import bannerImage from '../img/aaaservices/baiinersuite.jpg'; // Adjust the path according to your project structure

const WhoweareBanner = () => {
  return (
    <div 
  style={{
    position: "relative", 
    width: "100%", 
    height: "500px"
  }}
>
  <img 
    className="banner-image" 
    src={bannerImage} 
    alt="About AA Applications Banner" 
    style={{ 
      width: "100%", 
      height: "100%", 
      objectFit: "cover" 
    }} 
  />
  <div 
    style={{
      position: "absolute", 
      top: 0, 
      left: 0, 
      width: "100%", 
      height: "100%", 
      backgroundColor: "rgba(0, 0, 0, 0.5)" // Black overlay with 50% opacity
    }} 
  />



      
<div 
  className="hero-content-1 hero-content-position slide-up-text" 
  style={{ color: '#fff', marginTop: '130px' }}
>
  <h1 style={{ color: "#fff", fontSize: "25px", fontFamily: 'Raqupine Regular' }}>
    <span>About our Hotel</span>
  </h1>
</div>
<>
  <style>{`
    @keyframes slideUp {
      from {
        transform: translateY(50px);
        opacity: 0;
      }
      to {
        transform: translateY(0px);
        opacity: 1;
      }
    }

    .slide-up-text {
      animation: slideUp 1s ease-out forwards;
    }
  `}</style>
  </>
    </div>
   
  );
};

export default WhoweareBanner;



// import React from 'react';
// import bannerVideo from '../img/aaaservices/red.mp4'; // Adjust the path according to your project structure

// const WhoweareBanner = () => {
//   return (
//     <div className="hero-area overly-style-1 opacity-point-4">
//       {/* Replace image with video */}
//       <video 
//         className="banner-video" 
//         src={bannerVideo} 
//         autoPlay 
//         loop 
//         muted 
//         playsInline 
//         style={{ width: '100%', height: '914px', objectFit: 'cover' }}
//       >
//         Your browser does not support the video tag.
//       </video>
      
//       <div className="hero-content-1 hero-content-position" style={{ color: '#fff', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
//         <h1 style={{ color: "#fff", fontSize: "48px", fontFamily: 'Raqupine Regular',marginTop:'750px' }}>
//           <span style={{ fontFamily: 'Raqupine Regular' }}>TRAVLES</span>
//         </h1>
//       </div>
//     </div>
//   );
// };

// export default WhoweareBanner;

